import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { KnowledgeBaseService } from "./knowledge-base.service";
import { fuseAnimations } from '@fuse/animations';
import * as $ from 'jquery';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { lang_changelog } from 'app/idiomas/i18n/changelog/changelog.lang';

@Component({
  selector: 'app-knowledge-base',
  templateUrl: './knowledge-base.component.html',
  styleUrls: ['./knowledge-base.component.scss'],
  animations   : fuseAnimations
})
export class KnowledgeBaseComponent implements OnInit {

  urlSafe: SafeResourceUrl;
  tokenObtenido: boolean;
  urlKB = "https://kb01.culturalgo.com/?rest_route=/simple-jwt-login/v1/autologin&JWT=*TOKEN*";

  constructor(
    public sanitizer: DomSanitizer,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private kbs: KnowledgeBaseService
  ) {
    lang_changelog.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit(): void {
    const datosUsuarioActual:any = JSON.parse(localStorage.getItem('userData'));
    this.kbs.loginKB({email:datosUsuarioActual.user}).subscribe((respuesta:any) => {
      console.log("loginKB:",respuesta);
      if(respuesta.success){
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlKB.replace('*TOKEN*', respuesta.jwt));
        this.tokenObtenido = true;
        // window.open(this.urlKB.replace('*TOKEN*', respuesta.jwt), '_blank');
        // window.open('https://www.google.com', '_blank');
        setTimeout(() => {
          // const link = document.createElement('a');
          // link.target = '_blank';
          // link.href = this.urlKB.replace('*TOKEN*', respuesta.jwt);
          // link.click();
          // link.remove();
          this.urlKB = this.urlKB.replace('*TOKEN*', respuesta.jwt);
          $("#botonKB").click();
        },100);
      }
    });
  }

}
